import { Component, Inject, OnInit } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef,
} from '@angular/material/dialog';
import { EntitatiService } from '../entitati.service';
import { ViewEntitate } from '../entitati.interface';
import { helper } from 'src/environments/helper';

@Component({
    selector: 'app-view-entitate',
    templateUrl: './view-entitate.component.html',
    styleUrls: ['./view-entitate.component.scss'],
})
export class ViewEntitateComponent {
    helper = helper;
    isLoading: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ViewEntitate,
        private dialogRef: MatDialogRef<ViewEntitateComponent>,
        public entitateService: EntitatiService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }
}
